import React from 'react'
import UserAdapter from 'common/adapters/UserAdapter'
import UserService from 'common/Services/UserService'
import NotificationConductor from 'common/conductors/NotificationConductor'
import { ModalService } from 'services/ModalService'
import GamesService from 'services/GamesService'
import { isFunction } from 'utils/object-helper'
import selfExclusionNotification from 'features/SelfExclusion/SelfExludedNotification'
import UrlHistoryService from 'services/UrlHistoryService'
import { useHistory } from 'react-router-dom'

import { Login as NewLogin } from '@bet25/ui'
import { getCookie } from 'services/CookieService'
import productIcon from '../../images/icon-product-login.png'

const Login = (props) => {
    const history = useHistory()
    const closeModal = (modalName = '') => {
        isFunction(props.close)
            ? props.close(modalName)
            : props.actions.hideModal(modalName)

        history.push('/')
    }

    const loginHandler = (
        userName,
        password,
        setLoading,
        onSuccess = () => {}
    ) => {
        UserAdapter.login(userName, password)
            .then((res) => {
                onSuccess()
                UserService.attachUser()
                UserService.setIsUserLoggedIn((userData) => {
                    window.dataLayer.push({
                        event: 'Login',
                        userId: userData.userId,
                    })
                    ModalService.closeModal('LOGIN')
                }).then(() => {
                    UserService.showPinLoginPopup()

                    // Check if there's a pending game to launch
                    GamesService.launchPendingGame(history, () => {
                        UrlHistoryService.openUserAreaAfterLogin(history)
                        if (
                            window.location.pathname
                                .split('/')
                                .indexOf('spil') >= 0
                        ) {
                            setTimeout(() => window.location.reload(), 0)
                        } else {
                            selfExclusionNotification()
                            GamesService.fetchFavorite(res.id)
                        }
                    })
                })
            })
            .catch((e) => {
                setLoading(false)

                if (e) {
                    NotificationConductor.error(e.errorMessage)

                    if (e.data) {
                        forgotPassHandler()
                    }
                } else {
                    console.error('Error during login: ' + e)
                }
            })
    }

    // const onKeyPress = (e) => {
    //     const key = e.charCode || e.keyCode || 0
    //     if (key === 13) {
    //         loginHandler()
    //     }
    // }

    const forgotPassHandler = () => {
        ModalService.closeModal('LOGIN')
        ModalService.showModal('LOGIN_FORGOT_PASS')
    }

    const itWasMitIdLogin = !!getCookie('isItInitialLogin')
    const callMitId =
        props.data.isMitId === true ||
        (props.data.isMitId === undefined && !itWasMitIdLogin)

    return (
        <NewLogin
            isMitIdLogin={callMitId}
            closeAction={closeModal}
            loginHandler={loginHandler}
            theme={'dark'}
            oldAPI={true}
            forgotPassHandler={forgotPassHandler}
            showResetPassword={true}
            productAvatar={productIcon}
        />
    )
}

export default Login
